import { cn } from '@/lib/utils';
import { insertEdge } from '../utils/cutOrder';

/**
 * The bar marking the edge a dragged item will come to rest against.
 *
 * `axis` is which way the list runs: `x` for the controller columns' cards,
 * `y` for the Tools step's stacked rows.
 */
function InsertBar({ after, axis }: { after: boolean; axis: 'x' | 'y' }) {
  return (
    <span
      aria-hidden
      className={cn(
        'absolute z-10 rounded-full bg-primary',
        axis === 'x'
          ? cn('inset-y-0 w-[3px]', after ? '-right-1.5' : '-left-1.5')
          : cn('inset-x-0 h-[3px]', after ? '-bottom-[2px]' : '-top-[2px]')
      )}
    />
  );
}

/** The bar for one slot, or nothing when that slot is not the live drop target. */
export function InsertBarSlot({
  ids,
  dragId,
  hot,
  index,
  axis,
}: {
  /** The list as rendered, so the bar can tell which way the item is coming. */
  ids: string[];
  dragId: string | null;
  /** The id currently under the pointer. */
  hot: string | null;
  index: number;
  axis: 'x' | 'y';
}) {
  const edge = insertEdge(ids, dragId, hot, index);
  if (!edge) return null;
  return <InsertBar after={edge === 'after'} axis={axis} />;
}
